<template>
 <div>
    <div class="video_wrapper">
      <div class="video_block">
        <div class="video-container">
          <video-wrapper ref="player"
                        :player="'youtube'"
                        :videoId="videoId"
                        @controls="vimeoControlStatus"
                        @ready="handleLoaded"
                        @pause="setPauseStatus"
                        @play="setCaptureTimestamp"
                        @ended="setEndedWebcamCapture"
          />
        </div>
        <div v-if="!vimeoControlStatus" class="video_overlay_wrapper"></div>
      </div>
    </div>
    <div class="col-md-12  video-play">
      <div v-if="!vimeoControlStatus" class="videoPlayPauseBtn text-center">
        <button class="btn btn-primary btn__player-custom" id="playpauseBtn" @click="setPlayPauseBtn"><img class="mr-2" v-if="isPaused" src="https://img.icons8.com/material/16/ffffff/play--v1.png"/><img class="mr-2" v-if="!isPaused" src="https://img.icons8.com/material/16/ffffff/pause--v3.png"/>{{(isPaused)? 'Play': 'Pause'}}</button>
        <!-- <button class="btn btn-primary ml-2 btn__player-custom" id="responsiveBtn" @click="setResponsiveBtn"><img class="mr-2" src="https://img.icons8.com/material/16/ffffff/full-screen--v1.png"/>Maximize</button> -->
      </div>
    </div>
    <div class="webcam_wrapper">
      <Webcam v-if="showWebcam" @showWebcam="showHideWebcam" :showWebcam="showWebcam" :captureCount="captureCount" :captureMode="'video'"></Webcam>
    </div>

  </div>
</template>

<script>
import Webcam from '@/components/template/Webcam'
// var $ = require('jquery')
var Cookies = require('vue-cookies')
var userPermissions = Cookies.get('userPermissions')
var Config = require('../../router/Config')

export default {
  components: { Webcam },
  name: 'Youtubevideo',
  props: ['videoId'],
  data () {
    return {
      vimeoControlStatus: false,
      topicVideoFaceCapture: (Config.clientFeature) ? Config.clientFeature.topicVideoFaceCapture : true,
      videoDuration: 0,
      imageCount: 4,
      captureCount: 1,
      pauseTimestamp: 0,
      pauseTimeSlot1: 0,
      pauseTimeSlot2: 0,
      pauseTimeSlot3: 0,
      pauseTimeSlot4: 0,
      checkPauseInterval: '',
      showWebcam: false,
      isSetCues: false,
      isVideoEnded: false,
      isPaused: true,
      isPlaying: false,
      constraints: {
        audio: false,
        video: { width: 1280, height: 720 }
      }
    }
  },
  beforeCreate: function () {
    if (!userPermissions.course_view) {
      this.$router.push('/')
    }
  },
  beforeMount: function () {
    if (userPermissions.youtube_features_panel) {
      this.vimeoControlStatus = true
    }
  },
  mounted () {
    console.log('Youtubevideo player Component mounted')
  },
  computed: {
    player () {
      return this.$refs.player.player
    }
  },
  beforeDestroy: function () {
    clearInterval(this.checkPauseInterval)
  },
  methods: {
    handleLoaded () {
      this.getDuration()
      console.log(this.player)
      // this.player.getVideoUrl().then(function (item) {
      //   console.log(item)
      // })
    },
    getDuration () {
      var self = this
      this.$refs.player.player.getDuration().then(function (duration) {
        self.videoDuration = duration
      })
    },
    setPauseStatus () {
      this.isPaused = true
      this.isPlaying = false
    },
    setCaptureTimestamp () {
      if (this.topicVideoFaceCapture) {
        if (!this.isSetCues) {
          var timeSlot = parseInt(this.videoDuration / this.imageCount)
          console.log('setCaptureTimestamp')
          console.log(this.videoDuration)
          this.isSetCues = true
          for (let index = 0; index < this.imageCount; index++) {
            var randomTimeSlot = Math.floor(Math.random() * timeSlot + 1)
            var pauseTime = this.pauseTimestamp + randomTimeSlot
            this.pauseTimestamp += timeSlot
            if (index === 0) {
              this.pauseTimeSlot1 = pauseTime
              console.log(this.pauseTimeSlot1)
            }
            if (index === 1) {
              this.pauseTimeSlot2 = pauseTime
              console.log(this.pauseTimeSlot2)
            }
            if (index === 2) {
              this.pauseTimeSlot3 = pauseTime
              console.log(this.pauseTimeSlot3)
            }
            if (index === 3) {
              this.pauseTimeSlot4 = pauseTime
              console.log(this.pauseTimeSlot4)
            }
          }
        }
        var self = this
        this.checkPauseInterval = setInterval(function () {
          if (this.$refs.player) {
            this.$refs.player.player.getCurrentTime().then(function (currentTime) {
              if (self.captureCount === 1 && self.pauseTimeSlot1 === parseInt(currentTime)) {
                console.log('captureCount: 1 ' + currentTime)
                self.setWebcamCapture(self)
              }
              if (self.captureCount < 3 && self.pauseTimeSlot2 === parseInt(currentTime)) {
                console.log('captureCount: 2 ' + currentTime)
                self.setWebcamCapture(self)
              }
              if (self.captureCount < 4 && self.pauseTimeSlot3 === parseInt(currentTime)) {
                console.log('captureCount: 3 ' + currentTime)
                self.setWebcamCapture(self)
              }
              if (self.captureCount < 5 && self.pauseTimeSlot4 === parseInt(currentTime)) {
                console.log('captureCount: 4 ' + currentTime)
                self.setWebcamCapture(self)
              }
            })
          }
        }.bind(this), 1000)
      }
    },
    setWebcamCapture (event) {
      var self = this
      navigator.mediaDevices.getUserMedia(this.constraints).then(function (stream) {
        Cookies.set('captureCount', self.captureCount)
        self.showWebcam = true
        self.player.pauseVideo()
        self.isPaused = true
        self.isPlaying = false
        clearInterval(self.checkPauseInterval)
      }).catch(function (err) {
        console.log(err)
      })
    },
    setPlayPauseBtn () {
      if (this.isPaused) {
        this.player.playVideo()
        this.isPaused = false
        this.isPlaying = true
      } else {
        this.player.pauseVideo()
        this.isPaused = true
        this.isPlaying = false
      }
    },
    setResponsiveBtn () {
      this.player.getCurrentTime().then(function (seconds) {
        console.log('as',seconds)
      }).catch(function(error) {
        console.log('as',error)
      })
    },
    showHideWebcam (status) {
      this.showWebcam = status
      if (!this.isVideoEnded) {
        this.captureCount++
        this.player.playVideo()
        this.isPaused = false
        this.isPlaying = true
      } else {
        this.captureCount = 0
      }
      Cookies.set('captureCount', this.captureCount)
    },
    setEndedWebcamCapture () {
      console.log('captureCount: 5 == video ended')
      this.isVideoEnded = true
      if (this.topicVideoFaceCapture) {
        var self = this
        navigator.mediaDevices.getUserMedia(this.constraints).then(function (stream) {
          self.showWebcam = true
          self.pauseTimestamp = 0
          self.isSetCues = false
          clearInterval(self.checkPauseInterval)
        }).catch(function (err) {
          console.log(err)
        })
      }
      this.$emit('change-video-desc')
    }
  }
}
</script>

<style scoped lang="scss">
.subject_icon_block {
    height: 100%;
}

.video-container {
  overflow: hidden;
  position: relative;
  width:100%;
}
// changed for remove the long padding top of 56%
.video-container::after {
  padding-top: 0;
  display: block;
  content: '';
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.video_overlay_wrapper {
    width: 100%;
    height: 90%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
}

.btn__player-custom {
  background: #f7941d !important;
  color: #fff !important;
  font-family: 'Roboto', sans-serif !important;
  border-color: #f7941d;
}
</style>
